export const administrationData = [
  "configuring-page-access",
  "button-access-settings",
  "server-settings",
  "users",
  "document-display-options",
  "barcode-application-options",
  "mailboxes",
  "mailboxes-by-user",
];

export const documentCharacteristicsData = [
  "nomenclature-of-cases-current",
  "nomenclature-of-cases",
  "resolution-templates",
  "types-of-documents",
  "indexes-of-documents",
  "types-of-deliveries",
];

export const hrDepartmentData = [
  "profession-classifier",
  "job-categories",
  "types-of-structural-unit",
  "employees",
  "structural-units",
  "positions",
  "employees-and-contact-persons",
];

export const generalData = ["correspondents"];
